export type RequirementAdvanceFrequency = 'Monthly' | 'Quarterly' | 'SemiAnnually' | 'NoAdvances' | 'DueDateChange';

export const RequirementAdvanceFrequency = {
    Monthly: 'Monthly' as RequirementAdvanceFrequency,
    Quarterly: 'Quarterly' as RequirementAdvanceFrequency,
    SemiAnnually: 'SemiAnnually' as RequirementAdvanceFrequency,
    NoAdvances: 'NoAdvances' as RequirementAdvanceFrequency,
    DueDateChange: 'DueDateChange' as RequirementAdvanceFrequency
};
